export const REQUEST_INSIGHTS = "REQUEST_INSIGHTS";
export const RECEIVED_INSIGHTS = "RECEIVED_INSIGHTS";
export const ERROR_INSIGHTS = "ERROR_INSIGHTS";

export const INSIGHTS_NONE = "INSIGHTS_NONE";
export const INSIGHTS_REQUESTING = "INSIGHTS_REQUESTING";
export const INSIGHTS_RECEIVED = "INSIGHTS_RECEIVED";
export const INSIGHTS_ERROR = "INSIGHTS_ERROR";
